* {
  box-sizing: border-box;
}

:host {
  display: flex;
  align-items: start;
  justify-content: start;
}

gz-icon {
  margin-right: var(--spacer);
}

gz-text {
  .ipt-link-button {
    --button-font-size: var(--body-size);
  }
  .ipt-link-button::part(button) {
    font-weight: 400;
  }
}
